<div  class="mat-dialog-title">
  <h2>
    <mat-icon>logout</mat-icon>
    {{"sidebar.logout" | transloco}}
  </h2>
</div>
<mat-divider></mat-divider>
<mat-dialog-content>
  Sei sicuro di volere uscire?
</mat-dialog-content>
<mat-dialog-actions>
<!--  <button mat-raised-button mat-dialog-close >annulla</button>-->
<!--  <button mat-raised-button (click)="onLogout()">esci</button>-->

  <button mcButton variant="closedialog" type="button" mat-dialog-close>Annulla</button>
  <button mcButton variant="confirmdialog"   type="button" class="btnConfirmSave" (click)="onLogout()">Esci</button>
</mat-dialog-actions>
